import {Pipe, PipeTransform} from '@angular/core';

import {getFileNameAndExtension} from '../utils/files';

/**
 * Dumps anything as a JSON string
 */
@Pipe({name: 'gpDisplayFile'})
export class DisplayFilePipe implements PipeTransform {

  public transform(file: string, icon = false): string {
    const {fileName, fileExtension} = getFileNameAndExtension(file);
    const isPdf = icon && fileExtension === 'pdf';
    const escapedFileName = this.escapeHtml(fileName);
    return `${
      isPdf
        ? `<i aria-hidden="true" class="fa fa-light fa-file-pdf"></i><span class="m-l-sm">${escapedFileName}</span>`
        : `<span>${escapedFileName}</span>`
    }`;
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}
